/* eslint-disable */

import React from 'react';
import { transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      '$(function(){$(".h-rs-line").on("input",function(){var t=$(this).val(),i=$(this).attr("min"),i=(t-i)/($(this).attr("max")-i);$(".h-rs-indicator").text(t),$(".h-rs-indicator").css("left",i*($(".h-rs-line").width()-18))})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '$(function(){$(".h-rs-line").on("input",function(){var t=$(this).val(),i=$(this).attr("min"),i=(t-i)/($(this).attr("max")-i);$(".h-rs-indicator").text(t),$(".h-rs-indicator").css("left",i*($(".h-rs-line").width()-18))})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '$(function(){$(".h-rs-line").on("input",function(){var t=$(this).val(),i=$(this).attr("min"),i=(t-i)/($(this).attr("max")-i);$(".h-rs-indicator").text(t),$(".h-rs-indicator").css("left",i*($(".h-rs-line").width()-18))})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".billing-option").click(function(){$(".billing-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".bl-p-section").removeClass("active"),$(".bl-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".usage-option").click(function(){$(".usage-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".u-p-section").removeClass("active"),$(".u-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".cpc-tr").click(function(){$(".cpc").show().delay(1e3).fadeOut()}),$(".user-dots").on("click",function(){$(this).toggleClass("active")}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-skills-v7.webflow.io");$(this).attr("href",e)}),$(".submit-prompt").click(function(){$(".human-text").removeClass("hide"),setTimeout(function(){$(".s1")[0].style.display="flex"},1e3),setTimeout(function(){$(".s2")[0].style.display="flex"},2e3)}),$(".skills-option").click(function(){var e=$(this).attr("data-name");$(".skills-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$("html, body").animate({scrollTop:$(".scroll-div[data-name="+e+"]").offset().top-79},1e3)}),$(".item_options").each(function(){$(this).mouseover(function(){var e=$(this).closest("a").attr("href");$(this).closest("a").removeAttr("href"),$(this).closest("a").data("default_url",e)}),$(this).mouseout(function(){$(this).closest("a").data("default_url")&&$(this).closest("a").attr("href",$(this).closest("a").data("default_url"))}),$(this).click(function(){0<$(this).closest(".w-slider-mask").length&&($(this).closest(".w-slider-mask")[0].style.overflow="visible",$(".sl_c").css("z-index","auto"),$(this).closest(".sl_c")[0].style.zIndex="5",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="hidden"}),$(this).closest(".w-slide")[0].style.visibility="visible"),$(".options_div").each(function(e){$(this)[0].style.display="none"}),$(this).find(".options_div").toggle()})}),$(".item_options").click(function(e){e.stopPropagation()}),$(window).click(function(){$(".options_div").each(function(e){$(this)[0].style.display="none",0<$(this).closest(".w-slider-mask").length&&($(this).closest(".sl_c")[0].style.zIndex="auto",$(this).closest(".w-slider-mask")[0].style.overflow="hidden",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="visible"}))})}),$(".mobile_nav_trigger").click(function(){"block"!=$(".mobile_nav")[0].style.display?$(".mobile_nav")[0].style.display="block":$(".mobile_nav")[0].style.display="none"}),$(window).click(function(){$(".mobile_nav")[0].style.display="none"}),$(".mobile_nav").click(function(e){e.stopPropagation()}),$(".mobile_nav_trigger").click(function(e){e.stopPropagation()}),$(".link-options-2").click(function(){var e=$(this).attr("data-name");$(".link-options-2").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(e){$(this).removeClass("active")}),$(".panel[data-name="+e+"]").addClass("active")}),$(".open-chat").click(function(){$(".chatbox").addClass("open"),$(".ch_c").removeClass("hidden")}),$(".minimize").click(function(){$(".chatbox").removeClass("open"),$(".ch_c").addClass("hidden")}),$(".div-block-163").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(".div-block-167").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(window).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"})}),$(".div-block-163").click(function(e){e.stopPropagation()}),$(".div-block-167").click(function(e){e.stopPropagation()}),$(".br_menu").click(function(){$(".br_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".browse_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.browse_panel[data-name="\'+e+\'"]\')[0].style.display="flex"}),$(".f_row").each(function(){$(this).click(function(){$(this).find(".img_v").toggle(),$(this).find(".img_h").toggle(),$(this).next().toggle()})}),$(".f_box .text-field.w-input").each(function(){$(this).keyup(function(){let i=$(this).val();var e=$(this).parent().parent().find(".checkbox-field");$(e).each(function(e){0<=$(this).find(".checkbox-label")[0].innerHTML.toLowerCase().indexOf(i.toLowerCase())?$(this)[0].style.display="block":$(this)[0].style.display="none"})})}),$(".feed-option").click(function(){$(".feed-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".feed_cont").each(function(e){$(this).removeClass("active")}),$(\'.feed_cont[data-name="\'+e+\'"]\').addClass("active"),"messages"==e||"following"==e||"followers"==e?$("body").addClass("messages_active"):$("body").removeClass("messages_active")});var e=window.location.href,e=(console.log(e),e.split("#")[1]);function i(){$(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"),$(".tw_r.new_m_user").each(function(e){$(this).removeClass("active")})}e&&(e=document.querySelector(\'.prof_menu[data-name="\'+e+\'"]\'))&&e.click(),document.getElementById("pink0").oninput=function(){var e=(this.value-this.min)/(this.max-this.min)*100;this.style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+e+"%, #fff "+e+"%, white 100%)"},$("input[type=range]").on("input",function(){var t=$(this).attr("data-index"),l=$(this).val();$("#i"+t).html(l);{let i=0;$(".is-pink0").each(function(e){0<$(this).val()&&(i+=1)}),console.log(i),$("#rs").html(i),3==i?($(".skills_allow")[0].style.display="flex",$(".skills_next0").hide()):($(".skills_allow").hide(),$(".skills_next0").show())}{let e="",i="";0==l?(e="NOT RATED",i="0"):1==l?(e="BEGINNER",i="10px"):2==l?(e="NOVICE",i="60px"):3==l?(e="INTERMEDIATE",i="80px"):4==l?(e="ADVANCED",i="130px"):5==l&&(e="EXPERT",i="160px"),$(".level-text")[t].style.marginLeft=i,$(".level-text")[t].innerHTML=e}l=$(this)[0],t=(l.value-l.min)/(l.max-l.min)*100;$(this)[0].style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+t+"%, #e9eaeb "+t+"%, #e9eaeb 100%)"}),$(".is-pink0").on("touchstart",function(e){}),$(".is-pink0").on("touchend",function(){}),$(".more").click(function(){$(this).hide(),$(".link-block-7").each(function(e){$(this).removeClass("hide")})}),$(".down_arr").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$(".skills_next0.disabled").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills-v2.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$(".c-block").click(function(){$(".cm_popup_div")[0].style.display="flex"}),$(".comment-c").click(function(){$(".cm_popup_div")[0].style.display="none"}),$(".tw-img-trigger").click(function(){$("#tw-img-uploader").trigger("click")}),$(".likes_tab").click(function(){$(".likes_tab").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".profile_text").each(function(e){$(this).removeClass("active")}),$(\'.profile_text[data-name="\'+e+\'"]\').addClass("active"),$(".profile_list").each(function(e){$(this).removeClass("active")}),$(\'.profile_list[data-name="\'+e+\'"]\').addClass("active")}),$(".message_div .tw_r").click(function(){$(".message_div").addClass("mobile_hidden"),$(".chat_div").removeClass("mobile_hidden")}),$(".show_msg_div").click(function(){$(".message_div").removeClass("mobile_hidden"),$(".chat_div").addClass("mobile_hidden")}),$(".follow_tab").click(function(){var e=$(this).attr("data-name");e&&$(\'.feed-option[data-name="\'+e+\'"]\').click()}),$(".follow_tabs_back").click(function(){$(\'.feed-option[data-name="home"]\').click()}),$(".create-group").click(function(){$(".create_group_popup").removeClass("hidden"),$(".new_message_popup").addClass("hidden")}),$(".back_dc").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden")}),$(".cancel_user.c_i").click(function(){i()}),$(".next_form.n_m.next").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden"),$(this).hasClass("disabled")||($(".nm_popup")[0].style.display="none",i())}),$(".new_message").click(function(){$(".nm_popup")[0].style.display="flex"}),$(".tw_r.new_m_user").each(function(e){$(this).click(function(){$(this).toggleClass("active");let i=!1;$(".tw_r.new_m_user").each(function(e){$(this).hasClass("active")&&(i=!0)}),i?($(".n_m.next").removeClass("disabled"),$(".create-group").addClass("hide"),$(".group-users").addClass("show")):($(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"))})}),$(".div-block-181").each(function(e){$(this).click(function(){$(this).find(".div-block-193").toggle()})}),$(".cancel_type_popup").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".cancel_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".add_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".div-block-176").each(function(e){$(this).click(function(){$(".add_content_popup")[0].style.display="none",$(".type_content_popup")[0].style.display="block"})}),$(".content_menu").click(function(){$(".content_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".conent_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.conent_panel[data-name="\'+e+\'"]\')[0].style.display="block","type"==e?$(".add_content_btn").addClass("disabled"):$(".add_content_btn").removeClass("disabled")}),$(".add_content_div").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_content_popup")[0].style.display="block"})}),$(".add_content_btn").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_content").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_popup").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".dc").click(function(){$(".popup_div")[0].style.display="flex",$(".body")[0].style.overflow="hidden",$(".dc_popup")[0].style.display="block"}),$(".cancel_dc").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_dc_div").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_profile_trigger").click(function(){$(".popup_div")[0].style.display="flex",$(".edit_profile_pop")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".cancel_edit_profile").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_edit_prof").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".save_profile_info").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_rating").click(function(){$(".skill_report_popup")[0].style.display="none",$(".rate_skill_popup")[0].style.display="block"}),$(".rate_skill_close").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".cancel_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".confirm_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".skill_box").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".skill_report_popup").toggle()})}),$(".cancel_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".confirm_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".add_skill").click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_skill_popup").toggle()}),$(".confirm_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".cancel_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".dash_nav_item").click(function(){$(".dash_nav_item").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this)[0].innerHTML;$(".panel").each(function(e){$(this)[0].style.display="none"}),$(".panel-"+e.toLowerCase())[0].style.display="flex"}),window.location.hash.substr(1)&&(console.log("fires"),e=window.location.hash.substr(1),$(\'.prof_menu[data-name="\'+e+\'"]\').click());e=new URL(window.location.href).searchParams.get("s");console.log(e),e&&$(\'.prof_menu[data-name="\'+e+\'"]\').trigger("click")}),jQuery.fn.onPositionChanged=function(t,e){null==e&&(e=100);var l,o,s=$(this[0]);return s.length<1||(o=l=null,setInterval(function(){if(null==s||s.length<1)return s;null==l&&(l=s.position()),null==o&&(o=s.offset());var e=s.position(),i=s.offset();l.top==e.top&&l.left==e.left||($(this).trigger("onPositionChanged",{lastPos:l,newPos:e}),"function"==typeof t&&t(l,e),l=s.position()),o.top==i.top&&o.left==i.left||($(this).trigger("onOffsetChanged",{lastOff:o,newOff:i}),"function"==typeof t&&t(o,i),o=s.offset())},e)),s},$(window).on("scroll",function(){$(window).scrollTop()+$(window).height()==$(document).height()?$(".down_arr").hide():$(".down_arr").show()});'
    ),
    isAsync: false,
  },
];

let Controller;

class StartView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/StartController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = StartView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '6596e21ac435cac3c66baaef';
    htmlEl.dataset['wfSite'] = '6596e21ac435cac3c66baad8';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      StartView.Controller !== StartView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-skillspro-v3.webflow.css);


            .full.w-bar .right-content {
              display: flex !important;
              flex-direction: column !important;
          }
            @media screen and (min-width: 768px)  and  (max-width: 1090px){
              .div-block-19.cert-grid{
                  grid-template-columns: 1fr;
              }
          }
            .pr-text:after, .pr-text-2:after, .pr-text-3:after, .pr-text-4:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .div-block-346{
            	border-radius:2px;
            }
            .up{
            	white-space: nowrap;
            }
            .text-block-189{
            	margin-bottom:15px;
            }
            .div-block-345.u-p-section, .div-block-345.bl-p-section{
            	padding-top:15px !important;
            }
            .div-block-352.three-dots-menu{
            	height:132px !important;
            }
            .text-block-203{
            	margin-bottom:15px;
            }
            .div-block-357{
            	padding-bottom:12px;
            }
            .form-block.s_skill.r-search.s-r.search-admin{
            	margin-bottom:15px;  
            }
            .div-block-345.bl-p-section{
              	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .div-block-345.d-p-section{
            	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .cpc{
             margin-top:4px !important;
            }
            .user-dots.active{
              background-color: #f7f9fd;
          }
            .d-admin-m{
              height: 36px !important;
              width:152px !important;
          }
            .user-dots.active .d-admin-m{
              display:block; 
          }
            .pm-33{
            	height: 100%;
              display: flex;
              flex-direction: column;
            }
            .pm-272{
            	display: flex;
              flex-direction: column;
              flex-grow: 1;
            }
            .div-block-358{
            	    flex-grow: 1;
                  align-items: start;
            }
            .chat-box.logged-in.jc-start{
            	justify-content:start !important;
            }
          @media only screen and (max-width: 767px) {
              .text-block-167.new-chat-text, .text-block-186,  .text-block-184, .text-block-169 , .text-field-11.ask-input, .all,
              .text-block-192, .rel-answer.open .answer-text, .text-block-189, .textarea-2, .w_i, .create-text, .add-text,
              .rec-h, .text-field.n_text.s-f, .text-block-167.add-resource, .text-block-199, .text-field-12, .text-block-159-train, .text-block-196,
              .text-block-198, .text-block-160, .div-block-340-train .link-options-train, .text-block-165-tr, .text1-tr, .paragraph-tr, .text-block-163-tr, .text-block-86-tr,
              .text-block-86-tr, .instructor-name-train, .instructor-subtitle-train, .instructor-school-train, .text-block-165-train, .text-block-26, 
              .text-block-197, .test-name-3, .text-block-86, .text-block-120, .text-block-86, .question-title-te
              {
                  font-size: 16px !important;
              }
                .instructor-img-train{
                  width: 70px !important;
                  height: 70px !important
              }
              .text-block-191, .text-block-190, .b-link{
                  font-size:14px;
              }
              .image-45{
                  height:18px;
              }
              .content-2.r-hide{
                  padding-bottom:14px !important
              }
              .text-block-16.p, .text-block-124{
                  font-size:13px;
              }
          }
            @media only screen and (max-width: 767px) {
              .sign-in-panel {
              	padding-top:49px;
              }
              .chat-box-sign-in.hidden.open{
              border:none !important;
                height: auto !important;
              }
            }
            .chat-box-sign-in.hidden.open{
            	height:auto;
              padding-bottom:12px;
          	    	    margin-right:0;
              height:100%;
            }
            .or-3-copy{
            	text-align:center;
            }
            .chat-box-sign-in.hidden{
            	    border: 1px solid #dde1e6 !important;
            }
            .chat-1 .content-2{
            	padding-bottom:0 !important;
            }
            .div-block-305:hover {
              background-color: #fff;
          }
            .related_f{
            	display:none;
            }
            .sources_f{
            	display:none;
            }
            .create-div .text-field{
            	width: 100%;
            }
            .add_content_popup .div-block-333{
            	flex: inherit !important;
            }
            .b-link:hover{
            	text-decoration: underline;
            }
            .div-block-347{
            	padding:10px;
              z-index: 2222;
            }
            .b-link{
            	margin-right:6px !important;
            }
            .div-block-262.last{
            	padding-bottom:3px;
            }
            .about_p_popup_resource .about-box-train .faq-question-wrap-2{
              margin-bottom:0;
            }
              .about_p_popup_resource .faq-question-bar-2{
              padding-bottom:0;
            }
            .link-options-train.link-options:hover{
            	border-bottom: 2px solid #6cafe1;
            }
            .about-box-train .text-block-120{
            	    color: #6cafe1;
            }
            .question-title-te, .test-name-3{
             color: #6cafe1;
            }
            .link-options-train{
            	padding-right:0 !important;
            }
            .div-block-340-train{
            	padding-bottom:5px;
            }
            .about-box-train .faq-question-wrap-2{
            	padding-bottom:0;
            }
            .about-vox-train .accordion__title__faq-2{
            	padding:10px !important;
            }
            .about-box-train .div-block-270{
             padding:10px;
            }
            .link-options-train{
            	font-size:14px !important;
            }
            .rec-h{
            	height:40px;
            }
            .outcome-train .image-118{
            	width:16px;
              height:16px;
            }
            .div-block-333{
            	overflow:hidden;
            }
            .outcome-train .skill-div-2{
            	margin-bottom:5px;
              float:left !important;
              clear:both;
            }
            .outcome-train{
            	overflow:hidden;
            }
            .textarea-2{
            	height:250px !important;
              border-radius: 6px;
            }
            .text-block-187-sum:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .chat-1.hidden{
            	display:none;
            }
            .div-block-272{
            	z-index: 222;
            }
            .div-block-329{
            	max-width:350px;
            }
            .chat-box.hidden{
            	flex-grow: 1;
            }
            .chat-box.hidden.h-auto{
            	height: auto !important;
            }
            .rel-answer.open .answer-text{
            	display:block;
            }
            .right-content {
            	    max-height: 100vh;
              overflow: auto;
            }
            .div-block-325.rel{
            	padding-top:14px;
            }
            .h-hide{
            	display:none !important;
            }
            .all .grow-flex{
            	    overflow: auto;
            }
            .rec-div:hover .div-block-332{
              display: block;
          }
            @media screen and (max-width: 767px) {
              .all .grow-flex{
                  max-height: 89vh;
              }
          }
          /* .all .div-block-325.rel{
              position:absolute !important;
          } */
                .div-block-294-open:hover > .hidden-img{
              display:none;
          }
          .div-block-294-open:hover > .hidden-img-rot{
              display:block;
          }
            .rel-answer.open .answer-text{
              height: auto;
              margin-bottom:10px;
          }
            .div-block-294:hover > .image-116{
              display:none;
          }
          .div-block-294:hover > .image-93-rot{
              display:inline-block;
          }
            .rel-row.open .div-block-294{
              display:none;
          }
          .rel-row.open .div-block-294-open{
              display:inline-block;
          }
            .chat-response .form-2{
            	height:40px;
            }
            .chat-box.hidden{
            	height:100% !important;
            }
            .graphs-row{
                	overflow: auto !important;
            }
            .second-input{
            	display:flex;
              align-items:center;
            }
            	@media screen and (max-width: 767px) {
                    .html-embed-2.skill-point.dblock.w-embed.w-script{
                  overflow: auto !important;
                min-width: 600px !important;
              }
                    .reg-show{
                  display: block;
              }
              .form-block-8{
                  padding-top: 0;
              }
                	    .div-block-280{
                  display: none;;
              }
                	    .div-block-272{
                  position: fixed;
                  top: 0;
                  width: 100%;
                  background: #fff;
              }
              .div-block-52{
                  padding-top: 59px;
              }
                	    .chat-2{
                  position: fixed;
                  bottom: 0;
                  width: 100%;
                  background: #fff;
                                margin-bottom: 0;
                  padding-bottom: 14px;
              }
                    .content-2{
                  padding-bottom:100px;
              }
                	    .full.w-bar .chat-box.hidden{
                  border-radius: 0;
                  border: none !important;
              }
                	    .body.chat-active{
                  overflow: hidden;
              }
             .full.w-bar .image-106.right{
                  padding-right:13px;
              } 
              .div-block-325{
                  position: fixed !important;
                  background: #fff;
                  padding-top:12px;
                        margin-left: 0;
                  margin-right: 0;
                        padding-left: 10px;
                  padding-right: 10px;
              }
              .grow-flex{
                  padding-bottom: 66px;
              }
              .full.w-bar .right-content{
                  width: 100% !important;
                        overflow: auto;
                        padding: 0;
              }
              .chat-box{
                  min-height: auto;
                  height:auto;
                  flex-grow: 1;
              }
              .mob-grid{
                  margin-left: auto;
                  margin-right: auto;
              }
              .resize-img{
                  display: none;;
              }
                    .div-block-326{
                  min-width: auto !important;
              }
            }
              @media screen and (max-width: 390px) {
              .div-block-275{
                  margin-right: 8px;
              }
          }
              .with_blink:after{
            	-webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
              color: #21232e;
            }
            	  .no-after:after{
            	content:\"\" !important;
            }
            @keyframes blink {
            0% {
              display: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          /* Apply the animation to an element */
          .blink {
            animation: blink 1s ease-in-out infinite;
          }
          .text-block-187:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .full.w-bar .p_menu {
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
              .chat-box.active.hidden{
            	border-radius: 4px;
            }
          .full.w-bar .right-content{
              display: flex !important;
              flex-direction: column !important;
          }
            .full.w-bar .image-116.right .sm{
              margin-left: auto;
          }
            .full.w-bar .chat-box.hidden{
              display: flex;
          }
            .full.w-bar .p_menu.w_bar{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            .full.w-bar .panels_cont{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            	.full.w-bar .main-content{
              padding-right:380px;
          }
            .full.w-bar .right-content{
              display: block;
          }
          .full.w-bar .right-content{
              width:380px;
          }
            .chat-box{
            	width:auto !important;
              border: 1px solid #dde1e6 !important;
            }
            .about-panels{
              min-height: calc(100vh - 79px - 59px);
          }
          @media screen and (max-width: 767px)  and (min-width: 480px){
            .chatbox.open .open-chat{
              display: none;
            }
            .ch_c{
              margin-bottom: 0;
            }
          }
            .chatbox {
            padding-bottom: env(safe-area-inset-bottom);
                padding-top: env(safe-area-inset-top);
          }
              .about-body{
            	  min-height: calc(100vh - (79px + 58px))
            }
            input[type=range] {
            border-radius: 8px;
            height: 7px;
            outline: none;
            transition: background 450ms ease-in;
            -webkit-appearance: none;
          }
            .fs-rangeslider_track{
            	pointer-events: none;
            }
            .is-pink{
            	    pointer-events: auto;
            }
            .menicon{
            	    -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #4a78b8, #6cafe1);
            }
            .messages_active .al-m.active {
            margin-bottom: 0;
          }
            .tw_r.new_m_user.active .user_tick{
            display: block;
          }
            .body.messages_active .panels{
            padding-bottom: 0;
          }
          .body.messages_active .panels_cont{
          padding-bottom: 0;
          }
            .feed-option.active .tw_t{
            font-weight: 500;
          }
              ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(0,0,0,0.1);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(0,0,0,0.2);
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(0,0,0,0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(0,0,0,.9);
          }
            .add_content_btn.disabled{
            	opacity:0.7;
            }
            .text-block-16{
            overflow-wrap: break-word;
            }
            @media screen and (max-width: 1231px) {
          .results{
            grid-template-columns: 1fr 1fr;
          }
          }
            .inner span {
           	position: relative;
              top:2px;
            }
            .s_box{
                appearance: none;
              background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e\");
              background-repeat: no-repeat;
              background-position: right 7px center;
              background-size: 1em;
            }
              @media screen and (max-width: 479px) {
          .results{
            grid-template-columns: 1fr;
          }
          }
          @media screen and (max-width: 1250px) and (min-width: 991px) {
            .slider.w-slider .link-block-7:last-child{
              display: none;
            }
            .div-block-42.sl{
              grid-template-columns: 1fr 1fr 1fr;
            }
          }
            .div-block-78{
            	min-height: calc(100vh - 78px - 70px);
            }
            @media screen and (max-width: 479px) {
           .div-block-78{
            	min-height: calc(100vh - 78px - 101px);
            }
          }
            <style>
            .wday, .month{
            fill: #6d717f;
          }
          .float-right{
            color: #6d717f;
          }
            .more:hover {
                  background-color: #fff;
              background-image: none !important;
          }
            @media screen and (max-width: 479px){
              .dots{
              	    left: calc(50% - 19px);
              }
            }
            	  .chat-box.hidden{
            	height: auto !important;
            }
            @media screen and (max-width: 767px) {
              .chat-box.hidden{
                  height: 100% !important;
              }
                  .full.w-bar .main-content{
                  display:none;
              }
          }
            .chat-2{
            	padding-top: 14px;
            }
            .chat-box.logged-in.hidden{
            	display:none;
            }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="welcome_div show">
              <div className="p1">
                <div className="nav w_n">
                  <div className="nav-cont welcome">
                    <div className="nav-left">
                      <img
                        alt=""
                        className="image"
                        loading="lazy"
                        src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="div-block-78 p1-block">
                  <div className="div-block-79">
                    <img
                      alt=""
                      className="image-47"
                      loading="lazy"
                      sizes="(max-width: 479px) 100vw, 382.7578125px"
                      src="images/Untitled-1.jpg"
                      srcset="images/Untitled-1-p-500.jpeg 500w, images/Untitled-1.jpg 639w"
                    />
                    <div className="div-block-80">
                      <div className="text-block-60">Welcome to IBL Skills</div>
                      <div className="text-block-61">
                        Let’s set your learning profile. It will be used to find
                        instructional content personalized to your skills and
                        goals. These selected resources, along with our
                        AI-driven pedagogical method, will allow you to boost
                        your career and set a successful life-long learning
                        experience.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome_footer">
                  <div className="dots">
                    <div className="div-block-82 active"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                  </div>
                  <div className="div-block-81">
                    <div
                      className="g_s_btn first_btn"
                      data-w-id="e4983720-d1af-91c4-fab3-e55ae43faf72"
                    >
                      <div>Get Started</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p2">
                <div className="nav w_n">
                  <div className="nav-cont welcome">
                    <div className="nav-left">
                      <img
                        alt=""
                        className="image welcome"
                        loading="lazy"
                        src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="div-block-78">
                  <div className="div-block-84 role">
                    <div className="text-block-62">Select Your Role</div>
                    <div className="div-block-232">
                      <div className="role_div">
                        <div className="text-block-145">Data Scientist</div>
                        <div className="text-block-146">
                          Ruby, Data Analytics, R, Hadoop, Big Data Analysis
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Data Analyst</div>
                        <div className="text-block-146">
                          Data Wrangling, Tableau, Data Validation, Data
                          Visualization, Microsoft Excel
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Software Engineer</div>
                        <div className="text-block-146">
                          Product Lifecycle Management, Agile Development,
                          Software Development, Software Testing, Software
                          Architecture
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">
                          Marketing Specialist
                        </div>
                        <div className="text-block-146">
                          Branding, Product Marketing, Marketing Communications,
                          Social Media Marketing, Online Advertising
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Sales Manager</div>
                        <div className="text-block-146">
                          Marketing Strategy, Leadership, Personal Selling,
                          Sales Planning, Channel Marketing
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">UX Designer</div>
                        <div className="text-block-146">
                          User-Centered Design, Web Accessibility, Wireframing,
                          Information Architecture, User Research, Design
                          Thinking, CSS, HTML5, Web Application ...
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Business Analyst</div>
                        <div className="text-block-146">
                          Ideation, Presenting, Business Analysis, Software
                          Testing, Agile Development
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Financial Analyst</div>
                        <div className="text-block-146">
                          Wealth Management, Investment Banking, Mergers and
                          Acquisitions, Financial Modeling, Financial Analysis
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">
                          Human Resources Manager
                        </div>
                        <div className="text-block-146">
                          Program Development, Performance Management,
                          Presenting, Employee Relations, Staffing
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Product Manager</div>
                        <div className="text-block-146">
                          Process Design, Just-In-Time Production, Data
                          Visualization, New Product Development, Solution
                          Selling
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Project Manager</div>
                        <div className="text-block-146">
                          Process Design, Just-In-Time Production, Data
                          Visualization, New Product Development, Solution
                          Selling
                        </div>
                      </div>
                      <div className="role_div">
                        <div className="text-block-145">Operation Manager</div>
                        <div className="text-block-146">
                          Customer Experience, Online Research, Operations
                          Management, Inventory Control, Entrepreneurship
                        </div>
                      </div>
                    </div>
                    <div className="form-block welcome w-form">
                      <form
                        className="form welcome_f"
                        data-name="Email Form"
                        data-wf-element-id="70b076f3-9681-eba1-cb85-a403ca22711d"
                        data-wf-page-id="6596e21ac435cac3c66baaef"
                        id="email-form"
                        method="get"
                        name="email-form"
                      >
                        <div className="div-block">
                          <img
                            alt=""
                            className="image-2"
                            loading="lazy"
                            src="images/magnifying-glass_1magnifying-glass.png"
                          />
                        </div>
                        <input
                          className="text-field np w-input"
                          data-name="Email 6"
                          id="email-6"
                          maxLength={256}
                          name="email-6"
                          placeholder="Search for a Role"
                          required=""
                          type="email"
                        />
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>
                          Oops! Something went wrong while submitting the form.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome_footer">
                  <div className="dots">
                    <div className="div-block-82"></div>
                    <div className="div-block-82 active"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                  </div>
                  <div className="div-block-81">
                    <div
                      className="g_s_btn-before"
                      data-w-id="70b076f3-9681-eba1-cb85-a403ca227194"
                    >
                      <div>Previous Step</div>
                    </div>
                    <div
                      className="g_s_btn"
                      data-w-id="70b076f3-9681-eba1-cb85-a403ca227197"
                    >
                      <div>Next Step</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p3">
                <div className="nav w_n">
                  <div className="nav-cont welcome">
                    <div className="nav-left">
                      <img
                        alt=""
                        className="image welcome"
                        loading="lazy"
                        src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="div-block-78 sp">
                  <div className="div-block-84 sk">
                    <div className="text-block-62 res">
                      Add More Skills to Your Profile or Select New Ones
                    </div>
                    <div className="form-block welcome sk skills w-form">
                      <form
                        className="form welcome_f skills"
                        data-name="Email Form"
                        data-wf-element-id="dc97225f-b84a-9dd6-e423-3fd9ca50b85d"
                        data-wf-page-id="6596e21ac435cac3c66baaef"
                        id="email-form"
                        method="get"
                        name="email-form"
                      >
                        <div className="div-block">
                          <img
                            alt=""
                            className="image-2"
                            loading="lazy"
                            src="images/magnifying-glass_1magnifying-glass.png"
                          />
                        </div>
                        <input
                          className="text-field np w-input"
                          data-name="Email 6"
                          id="email-6"
                          maxLength={256}
                          name="email-6"
                          placeholder="Search for more skills you want to develop"
                          required=""
                          type="email"
                        />
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>
                          Oops! Something went wrong while submitting the form.
                        </div>
                      </div>
                    </div>
                    <a
                      className="link-8 hide"
                      data-w-id="df7c1753-df3a-cfe6-c601-0b4026e9089d"
                      href="#"
                    >
                      See suggested skills
                    </a>
                    <div className="sug_skills">
                      <div className="tx_s">18 Selected Skills</div>
                      <div className="div-block-83 sp">
                        <div className="div-block-17">
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Event Management
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Leadership
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Marketing
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Software Development
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Communication
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Software Project Management
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Local Government
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Social Media Marketing
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Social Commentary
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Feminism
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Socieconomics
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Business Comminications
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Communication Skills
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">
                              Computer Skills
                            </div>
                          </div>
                          <div className="div-block-16 welcome">
                            <div className="text-block-12 welcome">Editing</div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Graphic Design
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Information Architecture
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Research
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Socieconomic development
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Software Testing
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Time Management
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Leadership Dallas
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Instructional Design
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Qualitative Research
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Socioeconomic Impact of Female Education
                            </div>
                          </div>
                          <div className="div-block-16 welcome selected">
                            <img
                              alt=""
                              className="image-48"
                              loading="lazy"
                              src="images/checked_1checked.png"
                            />
                            <div className="text-block-12 welcome selected">
                              Change Management
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="add_skills">
                        <img
                          alt=""
                          className="image-52"
                          loading="lazy"
                          src="images/plus-1_1plus-1.png"
                        />
                      </div>
                    </div>
                    <div className="text-block-150 rate">
                      Now, Self Rate at Least Three Skills
                    </div>
                  </div>
                  <div className="ski_table">
                    <div className="div-block-253">
                      <div className="skh">
                        <div className="c _0">
                          <img
                            alt=""
                            className="image-95"
                            loading="lazy"
                            src="images/question-mark-on-a-circular-black-background_1question-mark-on-a-circular-black-background.png"
                          />
                        </div>
                        <div className="c left s">
                          <div>Skill</div>
                        </div>
                        <div className="c _40 left">
                          <div>Self Rating</div>
                        </div>
                        <div className="c left _10">
                          <div>Source</div>
                        </div>
                        <div className="c">
                          <div>Remove</div>
                        </div>
                      </div>
                      <div className="skr">
                        <div className="c _0">
                          <img
                            alt=""
                            className="image-95 l"
                            loading="lazy"
                            src="images/star_2star.png"
                          />
                        </div>
                        <div className="c left s">
                          <div>Event Management</div>
                        </div>
                        <div className="c _40 left">
                          <div className="level-sld">
                            <div className="div-block-87">
                              <div className="step_n _0">0</div>
                              <div className="step_n l4">1</div>
                              <div className="step_n l4">2</div>
                              <div className="step_n _2">3</div>
                              <div className="step_n">4</div>
                              <div className="step_n">5</div>
                            </div>
                            <div className="fs-rangeslider_form w-form">
                              <form
                                data-name="Email Form"
                                data-wf-element-id="f3cfb3f2-bdc0-10ae-f311-be7ac7d4c757"
                                data-wf-page-id="6596e21ac435cac3c66baaef"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div
                                  className="fs-rangeslider_wrapper hide hidden"
                                  fs-rangeslider-element="wrapper"
                                  fs-rangeslider-formatdisplay="true"
                                  fs-rangeslider-max={5}
                                  fs-rangeslider-min={0}
                                  fs-rangeslider-step={1}
                                >
                                  <div
                                    className="fs-rangeslider_track"
                                    fs-rangeslider-element="track"
                                  >
                                    <div
                                      className="fs-rangeslider_handle is-pink pink0"
                                      data-index={0}
                                      fs-rangeslider-element="handle"
                                      id="pink0"
                                    >
                                      <div className="fs-rangeslider_handle-value"></div>
                                    </div>
                                    <div
                                      className="fs-rangeslider_fill"
                                      fs-rangeslider-element="fill"
                                    ></div>
                                  </div>
                                  <input
                                    className="fs-rangeslider_input w-input"
                                    data-name="From 3"
                                    fs-cmsfilter-field="price"
                                    fs-cmsfilter-range="from"
                                    id="From-3"
                                    maxLength={256}
                                    name="From-3"
                                    placeholder="From"
                                    type="text"
                                  />
                                  <div className="fs-range_values hidden"></div>
                                </div>
                                <div className="w-embed w-script">
                                  <style
                                    media="screen"
                                    dangerouslySetInnerHTML={{
                                      __html: `
  .af-view {
  background: #000;
}
.af-view .h-rs {
  position: relative;
}
.af-view .h-rs-index {
  color: #FFF;
}
.af-view .h-rs-container {
  display: flex;
  flex-direction: column;
}
.af-view .h-rs-indicator {
  display: block;
  width: 50px;
  height: 35px;
  border-radius: 12px;
  text-align: center;
  line-height: 35px;
  background: #FFF;
  position: absolute;
  top: -30px;
  left: 0;
  margin-left: -16px;
}
.af-view .h-rs-indicator::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 9px solid #FFF;
  position: absolute;
  top: 98%;
  left: 50%;
  margin-left: -8px;
}
.af-view .h-rs-line {
  width: 300px;
  margin-top: 24px;
  -webkit-appearance: none;
  border-radius: 24px;
  background:#e9eaeb;
}
.af-view .h-rs-line::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: 8px;
  border-radius: 24px;
}
.af-view input[type=range] {
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
.af-view input[type=range]:focus {
  outline: none;
}
.af-view input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1px;
  border: 0px solid #010101;
}
.af-view input[type=range]::-webkit-slider-thumb {
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background: #4a78b8;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -6px;
}
.af-view input[type=range]::-moz-range-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #000000;
  background: #74A9D8;
  border-radius: 1px;
  border: 0px solid #010101;
}
.af-view input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000031;
  border: 1px solid #00001E;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #FFFFFF;
  cursor: pointer;
}
.af-view input[type=range]::-ms-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.af-view input[type=range]::-ms-fill-lower {
  background: #74A9D8;
  border: 0px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000;
}
.af-view input[type=range]::-ms-fill-upper {
  background: #74A9D8;
  border: 0px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000;
}
.af-view input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 1px 1px 1px #000031;
  border: 1px solid #00001E;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #FFFFFF;
  cursor: pointer;
}
.af-view input[type=range]:focus::-ms-fill-lower {
  background: #74A9D8;
}
.af-view input[type=range]:focus::-ms-fill-upper {
  background: #74A9D8;
}
.af-view input[type=range] {
  border-radius: 8px;
  height: 7px;
  outline: none;
  transition: background 450ms ease-in;
  -webkit-appearance: none;
}
 `,
                                    }}
                                  />
                                  <div className="h-rs-container">
                                    <div className="h-rs">
                                      <input
                                        className="h-rs-line is-pink0"
                                        data-index={0}
                                        defaultvalue={0}
                                        id="pink0"
                                        max={5}
                                        min={0}
                                        type="range"
                                      />
                                    </div>
                                    <div className="h-rs-index"></div>
                                  </div>
                                </div>
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div className="div-block-89">
                              <div className="level-text">NOT RATED</div>
                            </div>
                          </div>
                          <div className="div-block-236">
                            <div className="text-block-151" id="i0">
                              0
                            </div>
                          </div>
                        </div>
                        <div className="c left _10">
                          <div>Added Skill</div>
                        </div>
                        <div className="c">
                          <img
                            alt=""
                            className="image-94"
                            loading="lazy"
                            src="images/close_1close.png"
                          />
                        </div>
                      </div>
                      <div className="skr">
                        <div className="c _0">
                          <img
                            alt=""
                            className="image-95 l"
                            loading="lazy"
                            src="images/star_2star.png"
                          />
                        </div>
                        <div className="c left s">
                          <div>Communication</div>
                        </div>
                        <div className="c _40 left">
                          <div className="level-sld">
                            <div className="div-block-87">
                              <div className="step_n _0">0</div>
                              <div className="step_n l4">1</div>
                              <div className="step_n l4">2</div>
                              <div className="step_n _2">3</div>
                              <div className="step_n">4</div>
                              <div className="step_n">5</div>
                            </div>
                            <div className="fs-rangeslider_form w-form">
                              <form
                                data-name="Email Form"
                                data-wf-element-id="f3d29615-517a-b1c0-40fc-320c18e2da63"
                                data-wf-page-id="6596e21ac435cac3c66baaef"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div
                                  className="fs-rangeslider_wrapper hide hidden"
                                  fs-rangeslider-element="wrapper"
                                  fs-rangeslider-formatdisplay="true"
                                  fs-rangeslider-max={5}
                                  fs-rangeslider-min={0}
                                  fs-rangeslider-step={1}
                                >
                                  <div
                                    className="fs-rangeslider_track"
                                    fs-rangeslider-element="track"
                                  >
                                    <div
                                      className="fs-rangeslider_handle is-pink"
                                      data-index={1}
                                      fs-rangeslider-element="handle"
                                      id="pink2"
                                    >
                                      <div className="fs-rangeslider_handle-value"></div>
                                    </div>
                                    <div
                                      className="fs-rangeslider_fill"
                                      fs-rangeslider-element="fill"
                                    ></div>
                                  </div>
                                  <input
                                    className="fs-rangeslider_input w-input"
                                    data-name="From 3"
                                    fs-cmsfilter-field="price"
                                    fs-cmsfilter-range="from"
                                    id="From-3"
                                    maxLength={256}
                                    name="From-3"
                                    placeholder="From"
                                    type="text"
                                  />
                                  <div className="fs-range_values hidden"></div>
                                </div>
                                <div className="w-embed w-script">
                                  <style
                                    media="screen"
                                    dangerouslySetInnerHTML={{
                                      __html: `
  .af-view {
  background: #000;
}
.af-view .h-rs {
  position: relative;
}
.af-view .h-rs-index {
  color: #FFF;
}
.af-view .h-rs-container {
  display: flex;
  flex-direction: column;
}
.af-view .h-rs-indicator {
  display: block;
  width: 50px;
  height: 35px;
  border-radius: 12px;
  text-align: center;
  line-height: 35px;
  background: #FFF;
  position: absolute;
  top: -30px;
  left: 0;
  margin-left: -16px;
}
.af-view .h-rs-indicator::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 9px solid #FFF;
  position: absolute;
  top: 98%;
  left: 50%;
  margin-left: -8px;
}
.af-view .h-rs-line {
  width: 300px;
  margin-top: 24px;
  -webkit-appearance: none;
  border-radius: 24px;
  background:#e9eaeb;
}
.af-view .h-rs-line::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: 8px;
  border-radius: 24px;
}
.af-view input[type=range] {
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
.af-view input[type=range]:focus {
  outline: none;
}
.af-view input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1px;
  border: 0px solid #010101;
}
.af-view input[type=range]::-webkit-slider-thumb {
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background: #4a78b8;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -6px;
}
.af-view input[type=range]::-moz-range-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #000000;
  background: #74A9D8;
  border-radius: 1px;
  border: 0px solid #010101;
}
.af-view input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000031;
  border: 1px solid #00001E;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #FFFFFF;
  cursor: pointer;
}
.af-view input[type=range]::-ms-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.af-view input[type=range]::-ms-fill-lower {
  background: #74A9D8;
  border: 0px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000;
}
.af-view input[type=range]::-ms-fill-upper {
  background: #74A9D8;
  border: 0px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000;
}
.af-view input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 1px 1px 1px #000031;
  border: 1px solid #00001E;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #FFFFFF;
  cursor: pointer;
}
.af-view input[type=range]:focus::-ms-fill-lower {
  background: #74A9D8;
}
.af-view input[type=range]:focus::-ms-fill-upper {
  background: #74A9D8;
}
 `,
                                    }}
                                  />
                                  <div className="h-rs-container">
                                    <div className="h-rs">
                                      <input
                                        className="h-rs-line is-pink0"
                                        data-index={1}
                                        defaultvalue={0}
                                        id="pink1"
                                        max={5}
                                        min={0}
                                        type="range"
                                      />
                                    </div>
                                    <div className="h-rs-index"></div>
                                  </div>
                                </div>
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div className="div-block-89">
                              <div className="level-text">NOT RATED</div>
                            </div>
                          </div>
                          <div className="div-block-236">
                            <div className="text-block-151" id="i1">
                              0
                            </div>
                          </div>
                        </div>
                        <div className="c left _10">
                          <div>Added Skill</div>
                        </div>
                        <div className="c">
                          <img
                            alt=""
                            className="image-94"
                            loading="lazy"
                            src="images/close_1close.png"
                          />
                        </div>
                      </div>
                      <div className="skr">
                        <div className="c _0">
                          <img
                            alt=""
                            className="image-95 l"
                            loading="lazy"
                            src="images/star_2star.png"
                          />
                        </div>
                        <div className="c left s">
                          <div>Software Development</div>
                        </div>
                        <div className="c _40 left">
                          <div className="level-sld">
                            <div className="div-block-87">
                              <div className="step_n _0">0</div>
                              <div className="step_n l4">1</div>
                              <div className="step_n l4">2</div>
                              <div className="step_n _2">3</div>
                              <div className="step_n">4</div>
                              <div className="step_n">5</div>
                            </div>
                            <div className="fs-rangeslider_form w-form">
                              <form
                                data-name="Email Form"
                                data-wf-element-id="e8de9b55-d58f-66d1-4974-ed3ef982a8e6"
                                data-wf-page-id="6596e21ac435cac3c66baaef"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div
                                  className="fs-rangeslider_wrapper hide hidden"
                                  fs-rangeslider-element="wrapper"
                                  fs-rangeslider-formatdisplay="true"
                                  fs-rangeslider-max={5}
                                  fs-rangeslider-min={0}
                                  fs-rangeslider-step={1}
                                >
                                  <div
                                    className="fs-rangeslider_track"
                                    fs-rangeslider-element="track"
                                  >
                                    <div
                                      className="fs-rangeslider_handle is-pink"
                                      data-index={2}
                                      fs-rangeslider-element="handle"
                                      id="pink1"
                                    >
                                      <div className="fs-rangeslider_handle-value"></div>
                                    </div>
                                    <div
                                      className="fs-rangeslider_fill"
                                      fs-rangeslider-element="fill"
                                    ></div>
                                  </div>
                                  <input
                                    className="fs-rangeslider_input w-input"
                                    data-name="From 3"
                                    fs-cmsfilter-field="price"
                                    fs-cmsfilter-range="from"
                                    id="From-3"
                                    maxLength={256}
                                    name="From-3"
                                    placeholder="From"
                                    type="text"
                                  />
                                  <div className="fs-range_values hidden"></div>
                                </div>
                                <div className="w-embed w-script">
                                  <style
                                    media="screen"
                                    dangerouslySetInnerHTML={{
                                      __html: `
  .af-view {
  background: #000;
}
.af-view .h-rs {
  position: relative;
}
.af-view .h-rs-index {
  color: #FFF;
}
.af-view .h-rs-container {
  display: flex;
  flex-direction: column;
}
.af-view .h-rs-indicator {
  display: block;
  width: 50px;
  height: 35px;
  border-radius: 12px;
  text-align: center;
  line-height: 35px;
  background: #FFF;
  position: absolute;
  top: -30px;
  left: 0;
  margin-left: -16px;
}
.af-view .h-rs-indicator::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 9px solid #FFF;
  position: absolute;
  top: 98%;
  left: 50%;
  margin-left: -8px;
}
.af-view .h-rs-line {
  width: 300px;
  margin-top: 24px;
  -webkit-appearance: none;
  border-radius: 24px;
  background:#e9eaeb;
}
.af-view .h-rs-line::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  height: 8px;
  border-radius: 24px;
}
.af-view input[type=range] {
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
.af-view input[type=range]:focus {
  outline: none;
}
.af-view input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1px;
  border: 0px solid #010101;
}
.af-view input[type=range]::-webkit-slider-thumb {
  height: 20px;
  width: 20px;
  border-radius: 15px;
  background: #4a78b8;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -6px;
}
.af-view input[type=range]::-moz-range-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #000000;
  background: #74A9D8;
  border-radius: 1px;
  border: 0px solid #010101;
}
.af-view input[type=range]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000031;
  border: 1px solid #00001E;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #FFFFFF;
  cursor: pointer;
}
.af-view input[type=range]::-ms-track {
  width: 100%;
  height: 11px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.af-view input[type=range]::-ms-fill-lower {
  background: #74A9D8;
  border: 0px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000;
}
.af-view input[type=range]::-ms-fill-upper {
  background: #74A9D8;
  border: 0px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000;
}
.af-view input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 1px 1px 1px #000031;
  border: 1px solid #00001E;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #FFFFFF;
  cursor: pointer;
}
.af-view input[type=range]:focus::-ms-fill-lower {
  background: #74A9D8;
}
.af-view input[type=range]:focus::-ms-fill-upper {
  background: #74A9D8;
}
 `,
                                    }}
                                  />
                                  <div className="h-rs-container">
                                    <div className="h-rs">
                                      <input
                                        className="h-rs-line is-pink0"
                                        data-index={2}
                                        defaultvalue={0}
                                        id="pink2"
                                        max={5}
                                        min={0}
                                        type="range"
                                      />
                                    </div>
                                    <div className="h-rs-index"></div>
                                  </div>
                                </div>
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div className="div-block-89">
                              <div className="level-text">NOT RATED</div>
                            </div>
                          </div>
                          <div className="div-block-236">
                            <div className="text-block-151" id="i2">
                              0
                            </div>
                          </div>
                        </div>
                        <div className="c left _10">
                          <div>Added Skill</div>
                        </div>
                        <div className="c">
                          <img
                            alt=""
                            className="image-94"
                            loading="lazy"
                            src="images/close_1close.png"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome_footer">
                  <div className="dots">
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82 active"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                  </div>
                  <div className="div-block-81">
                    <div
                      className="g_s_btn-before"
                      data-w-id="9aa50997-bb9c-24ef-8f07-07e00266d9d3"
                    >
                      <div>Previous Step</div>
                    </div>
                    <div className="div-block-240">
                      <div className="div-block-241">
                        <div className="text-block-157">
                          <span id="rs">0</span> of 3 skills rated
                        </div>
                      </div>
                      <div className="skills_next0 disabled">
                        <div>Next Step</div>
                      </div>
                      <div
                        className="skills_allow"
                        data-w-id="9778b675-8467-cd17-98df-427e6ae65351"
                      >
                        <div>Next Step</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="div-block-243">
                  <div className="div-block-242 down_arr">
                    <img
                      alt=""
                      className="image-48-copy"
                      loading="lazy"
                      src="images/arrow-down-sign-to-navigate-1_1arrow-down-sign-to-navigate-1.png"
                      width={15}
                    />
                  </div>
                </div>
              </div>
              <div className="p4">
                <div className="nav w_n">
                  <div className="nav-cont welcome">
                    <div className="nav-left">
                      <img
                        alt=""
                        className="image welcome"
                        loading="lazy"
                        src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="div-block-78 res">
                  <div className="div-block-84 level_rate">
                    <div className="text-block-62 res">
                      Upload Your Resume (Optional)
                    </div>
                    <div className="text-block-147">
                      Our AI Engine will detect and add your skills to your
                      learning profile
                    </div>
                    <div className="div-block-233">
                      <div className="div-block-234">
                        <div className="div-block-235">
                          <img
                            alt=""
                            className="image-93"
                            loading="lazy"
                            src="images/upload_1upload.png"
                          />
                        </div>
                        <div>
                          <div className="text-block-148">
                            Drag and drop your resume
                          </div>
                          <div className="text-block-149">
                            (pdf, doc, docx; up to 5Mb)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome_footer">
                  <div className="dots">
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82 active"></div>
                    <div className="div-block-82"></div>
                  </div>
                  <div className="div-block-81">
                    <div
                      className="g_s_btn-before"
                      data-w-id="9928e986-ed6f-637d-c317-082c6b14b8b9"
                    >
                      <div className="text-block-113">Previous Step</div>
                    </div>
                    <div
                      className="g_s_btn-before skip"
                      data-w-id="3eae9302-eb11-698f-76b4-89e59390c401"
                    >
                      <div className="text-block-113">Skip Step</div>
                    </div>
                    <div
                      className="g_s_btn r_n"
                      data-w-id="9928e986-ed6f-637d-c317-082c6b14b8bc"
                    >
                      <div className="text-block-113">Next Step</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p5">
                <div className="nav w_n">
                  <div className="nav-cont welcome">
                    <div className="nav-left">
                      <img
                        alt=""
                        className="image welcome"
                        loading="lazy"
                        src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="div-block-78">
                  <div className="div-block-92">
                    <div className="text-block-66">
                      Start Boosting Your Skills!
                    </div>
                    <div className="text-block-67">
                      Check our content selection or manually add more learning
                      items
                    </div>
                    <img
                      alt=""
                      className="image-51"
                      loading="lazy"
                      src="images/4721728.jpg"
                    />
                  </div>
                </div>
                <div className="welcome_footer">
                  <div className="dots">
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82 active"></div>
                  </div>
                  <div className="div-block-81">
                    <div
                      className="g_s_btn-before"
                      data-w-id="b5575d53-82a4-eb35-2e00-06afccc31678"
                    >
                      <div>Previous Step</div>
                    </div>
                    <a
                      className="link-block-12 go w-inline-block"
                      href="register.html"
                    >
                      <div className="g_s_btn r_n go">
                        <div className="text-block-112">Go</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="hidden">
                <div className="nav w_n">
                  <div className="nav-cont welcome">
                    <div className="nav-left">
                      <img
                        alt=""
                        className="image welcome"
                        loading="lazy"
                        src="images/lg.png"
                      />
                    </div>
                  </div>
                </div>
                <div className="div-block-78">
                  <div className="div-block-84 level_rate">
                    <div className="text-block-62">Now, rate your level</div>
                    <div className="div-block-85">
                      <div className="text-block-63">Event Management</div>
                      <div className="div-block-86">
                        <img
                          alt=""
                          className="image-49"
                          loading="lazy"
                          src="images/invisible_1invisible.png"
                        />
                        <div>Visible only to you</div>
                      </div>
                      <div className="div-block-88">
                        <div className="div-block-87">
                          <div className="step_n">1</div>
                          <div className="step_n">2</div>
                          <div className="step_n">3</div>
                          <div className="step_n">4</div>
                          <div className="step_n">5</div>
                          <div className="step_n">6</div>
                          <div className="step_n">7</div>
                          <div className="step_n">8</div>
                          <div className="step_n">9</div>
                          <div className="step_n">10</div>
                        </div>
                        <div className="fs-rangeslider_form w-form">
                          <form
                            data-name="Email Form"
                            data-wf-element-id="bad5719a-410a-6dc1-4982-5068dd8b6a14"
                            data-wf-page-id="6596e21ac435cac3c66baaef"
                            id="email-form"
                            method="get"
                            name="email-form"
                          >
                            <div
                              className="fs-rangeslider_wrapper"
                              fs-rangeslider-element="wrapper"
                              fs-rangeslider-formatdisplay="true"
                              fs-rangeslider-max={90}
                              fs-rangeslider-min={0}
                              fs-rangeslider-step={10}
                            >
                              <div
                                className="fs-rangeslider_track"
                                fs-rangeslider-element="track"
                              >
                                <div
                                  className="fs-rangeslider_handle is-pink"
                                  fs-rangeslider-element="handle"
                                >
                                  <div className="fs-rangeslider_handle-value"></div>
                                </div>
                                <div
                                  className="fs-rangeslider_fill"
                                  fs-rangeslider-element="fill"
                                ></div>
                              </div>
                              <input
                                className="fs-rangeslider_input w-input"
                                data-name="From 3"
                                fs-cmsfilter-field="price"
                                fs-cmsfilter-range="from"
                                id="From-3"
                                maxLength={256}
                                name="From-3"
                                placeholder="From"
                                type="text"
                              />
                              <div className="fs-range_values hidden"></div>
                            </div>
                          </form>
                          <div className="w-form-done">
                            <div>
                              Thank you! Your submission has been received!
                            </div>
                          </div>
                          <div className="w-form-fail">
                            <div>
                              Oops! Something went wrong while submitting the
                              form.
                            </div>
                          </div>
                        </div>
                        <div className="div-block-89">
                          <div className="text-block-64">Beginner</div>
                          <div className="text-block-64 mgl">Expert</div>
                        </div>
                        <div className="div-block-90">
                          <img
                            alt=""
                            className="image-50"
                            loading="lazy"
                            src="images/Screenshot-2022-06-09-at-3.57.09-PM-copy.png"
                          />
                          <div className="text-block-65">
                            Can complete narrow and limited tasks requiring
                            basic skills with direct supervision or guidance.
                          </div>
                          <div className="div-block-91"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome_footer">
                  <div className="dots">
                    <div className="div-block-82"></div>
                    <div className="div-block-82"></div>
                    <div className="div-block-82 active"></div>
                    <div className="div-block-82"></div>
                  </div>
                  <div className="div-block-81">
                    <div
                      className="g_s_btn-before"
                      data-w-id="bad5719a-410a-6dc1-4982-5068dd8b6a33"
                    >
                      <div className="text-block-113">Previous Step</div>
                    </div>
                    <div
                      className="g_s_btn-before skip"
                      data-w-id="bad5719a-410a-6dc1-4982-5068dd8b6a36"
                    >
                      <div className="text-block-113">Skip Step</div>
                    </div>
                    <div
                      className="g_s_btn r_n"
                      data-w-id="bad5719a-410a-6dc1-4982-5068dd8b6a39"
                    >
                      <div className="text-block-113">Next Step</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="level-popup">
              <div className="popup_cont sk lvl">
                <div className="lvl" data-name="followers">
                  <div className="div-block-147">
                    <div>Rate your expertise in Leadership</div>
                    <img
                      alt=""
                      className="cancel_edit_profile"
                      loading="lazy"
                      src="images/close_2close.png"
                    />
                  </div>
                  <div className="div-block-84 level_rate l">
                    <div className="div-block-85 sp">
                      <div className="div-block-88">
                        <div className="level-sld">
                          <div className="div-block-87">
                            <div className="step_n">1</div>
                            <div className="step_n">2</div>
                            <div className="step_n">3</div>
                            <div className="step_n">4</div>
                            <div className="step_n">5</div>
                          </div>
                          <div className="fs-rangeslider_form w-form">
                            <form
                              data-name="Email Form"
                              data-wf-element-id="3e512c8f-e696-5716-5e08-624f09712015"
                              data-wf-page-id="6596e21ac435cac3c66baaef"
                              id="email-form"
                              method="get"
                              name="email-form"
                            >
                              <div
                                className="fs-rangeslider_wrapper"
                                fs-rangeslider-element="wrapper"
                                fs-rangeslider-formatdisplay="true"
                                fs-rangeslider-max={90}
                                fs-rangeslider-min={0}
                                fs-rangeslider-step={10}
                              >
                                <div
                                  className="fs-rangeslider_track"
                                  fs-rangeslider-element="track"
                                >
                                  <div
                                    className="fs-rangeslider_handle is-pink"
                                    fs-rangeslider-element="handle"
                                  >
                                    <div className="fs-rangeslider_handle-value"></div>
                                  </div>
                                  <div
                                    className="fs-rangeslider_fill"
                                    fs-rangeslider-element="fill"
                                  ></div>
                                </div>
                                <input
                                  className="fs-rangeslider_input w-input"
                                  data-name="From 3"
                                  fs-cmsfilter-field="price"
                                  fs-cmsfilter-range="from"
                                  id="From-3"
                                  maxLength={256}
                                  name="From-3"
                                  placeholder="From"
                                  type="text"
                                />
                                <div className="fs-range_values hidden"></div>
                              </div>
                            </form>
                            <div className="w-form-done">
                              <div>
                                Thank you! Your submission has been received!
                              </div>
                            </div>
                            <div className="w-form-fail">
                              <div>
                                Oops! Something went wrong while submitting the
                                form.
                              </div>
                            </div>
                          </div>
                          <div className="div-block-89">
                            <div className="text-block-64">BEGINNER</div>
                            <div className="text-block-64 mgl">EXPERT</div>
                          </div>
                        </div>
                        <div className="div-block-90">
                          <div className="div-block-239">
                            <div className="html-embed-5 w-embed">
                              <style
                                dangerouslySetInnerHTML={{
                                  __html: `
.af-view .wrap-circle_starts {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle_start {
  position: relative;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle_start.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle_start .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 45px;
  height: 45px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                }}
                              />
                              <div
                                className="circle_start per-25"
                                style={{
                                  backgroundImage:
                                    'conic-gradient(#528ac1 33%, #def 0)',
                                }}
                              >
                                <div className="inner">
                                  <span>1</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="text-block-65">
                            Can complete narrow and limited tasks requiring
                            basic skills with direct supervision or guidance.
                          </div>
                          <div className="div-block-91"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popup-f add_content">
                    <div
                      className="div-block-113 cancel_edit_prof"
                      data-w-id="e1736d06-9f7a-b1e5-4954-3deca35ffe3f"
                    >
                      <div className="text-block-81 cancel_dc">Cancel</div>
                    </div>
                    <div
                      className="div-block-113 ls"
                      data-w-id="e1736d06-9f7a-b1e5-4954-3deca35ffe42"
                    >
                      <div className="text-block-81 add_skill_text">Save</div>
                    </div>
                  </div>
                </div>
                <div className="add_skill_popup" data-name="followers">
                  <div className="div-block-147">
                    <div>Add Skill</div>
                    <img
                      alt=""
                      className="cancel_add_skill"
                      loading="lazy"
                      src="images/close_2close.png"
                    />
                  </div>
                  <div className="div-block-148">
                    <div className="div-block-149 sk_s">
                      <div className="form-block s_skill w-form">
                        <form
                          className="form"
                          data-name="Email Form"
                          data-wf-element-id="bc1081db-e249-ed90-8e03-e122760e76f9"
                          data-wf-page-id="6596e21ac435cac3c66baaef"
                          id="email-form"
                          method="get"
                          name="email-form"
                        >
                          <div className="div-block">
                            <img
                              alt=""
                              className="image-2"
                              loading="lazy"
                              src="images/magnifying-glass_1magnifying-glass.png"
                            />
                          </div>
                          <input
                            className="text-field n_text w-input"
                            data-name="Email 4"
                            id="email-4"
                            maxLength={256}
                            name="email-4"
                            placeholder="Search for skills"
                            required=""
                            type="email"
                          />
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popup-f">
                    <div className="div-block-113 confirm_add_skill">
                      <div className="text-block-81 add_skill_text">
                        Add Skill
                      </div>
                    </div>
                  </div>
                </div>
                <div className="skill_report_popup" data-name="followers">
                  <div className="div-block-147">
                    <div>Javascript</div>
                    <img
                      alt=""
                      className="cancel_skill_report"
                      loading="lazy"
                      src="images/close_2close.png"
                    />
                  </div>
                  <div className="div-block-148">
                    <div className="div-block-149 sk_s">
                      <div className="div-block-169">
                        <img
                          alt=""
                          className="image-79"
                          loading="lazy"
                          src="images/skills_icon_1skills_icon.png"
                        />
                        <div>
                          <div className="text-block-108">Self Rating</div>
                          <div className="text-block-107">Level 3</div>
                          <div className="edit_rating">Edit Rating</div>
                        </div>
                        <div className="item_options">
                          <div className="item_options_triger">
                            <img
                              alt=""
                              className="image-20"
                              loading="lazy"
                              src="images/menu_1menu.png"
                            />
                          </div>
                          <div className="options_div skill_options">
                            <div className="text-block-103">Clear Rating</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popup-f">
                    <div className="div-block-113 confirm_skill_report">
                      <div className="text-block-81 add_skill_text">Save</div>
                    </div>
                  </div>
                </div>
                <div className="rate_skill_popup" data-name="followers">
                  <div className="div-block-147">
                    <div>Rate your expertise in "Javascript"</div>
                    <img
                      alt=""
                      className="rate_skill_close"
                      loading="lazy"
                      src="images/close_2close.png"
                    />
                  </div>
                  <div className="div-block-148">
                    <div className="div-block-149 sk_s">
                      <div className="rate_skill r_popup">
                        <div className="rate_skill_block">
                          <div className="div-block-87">
                            <div className="step_n">1</div>
                            <div className="step_n">2</div>
                            <div className="step_n">3</div>
                            <div className="step_n">4</div>
                            <div className="step_n">5</div>
                            <div className="step_n">6</div>
                            <div className="step_n">7</div>
                            <div className="step_n">8</div>
                            <div className="step_n">9</div>
                            <div className="step_n">10</div>
                          </div>
                          <div className="fs-rangeslider_form w-form">
                            <form
                              data-name="Email Form"
                              data-wf-element-id="bc1081db-e249-ed90-8e03-e122760e7740"
                              data-wf-page-id="6596e21ac435cac3c66baaef"
                              id="email-form"
                              method="get"
                              name="email-form"
                            >
                              <div
                                className="fs-rangeslider_wrapper"
                                fs-rangeslider-element="wrapper"
                                fs-rangeslider-formatdisplay="true"
                                fs-rangeslider-max={90}
                                fs-rangeslider-min={0}
                                fs-rangeslider-step={10}
                              >
                                <div
                                  className="fs-rangeslider_track"
                                  fs-rangeslider-element="track"
                                >
                                  <div
                                    className="fs-rangeslider_handle is-pink"
                                    fs-rangeslider-element="handle"
                                  >
                                    <div className="fs-rangeslider_handle-value"></div>
                                  </div>
                                  <div
                                    className="fs-rangeslider_fill"
                                    fs-rangeslider-element="fill"
                                  ></div>
                                </div>
                                <input
                                  className="fs-rangeslider_input w-input"
                                  data-name="From 3"
                                  fs-cmsfilter-field="price"
                                  fs-cmsfilter-range="from"
                                  id="From-3"
                                  maxLength={256}
                                  name="From-3"
                                  placeholder="From"
                                  type="text"
                                />
                                <div className="fs-range_values hidden"></div>
                              </div>
                            </form>
                            <div className="w-form-done">
                              <div>
                                Thank you! Your submission has been received!
                              </div>
                            </div>
                            <div className="w-form-fail">
                              <div>
                                Oops! Something went wrong while submitting the
                                form.
                              </div>
                            </div>
                          </div>
                          <div className="div-block-89">
                            <div className="text-block-64">Beginner</div>
                            <div className="text-block-64 mgl">Expert</div>
                          </div>
                          <div className="div-block-90">
                            <div className="rate_level">
                              <div className="html-embed-5 rate_level w-embed">
                                <style
                                  dangerouslySetInnerHTML={{
                                    __html: `
/*** <--- CIRCLE STYLES ---> ***/
.af-view .wrap-circles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.af-view .circle {
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  overflow: hidden;
}
.af-view .circle.per-25 {
  background-image: conic-gradient(#369 33%, #def 0);
}
.af-view .circle .inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 50%;
  font-size: 32px;
  font-weight: 300;
  color: #528ac1;
}
   `,
                                  }}
                                />
                                <div
                                  className="circle per-25"
                                  style={{
                                    backgroundImage:
                                      'conic-gradient(#528ac1 30%, #def 0)',
                                  }}
                                >
                                  <div className="inner">
                                    <span>3</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="text-block-65">
                              Can complete narrow and limited tasks requiring
                              basic skills with direct supervision or guidance.
                            </div>
                            <div className="div-block-91"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popup-f rate">
                    <div className="div-block-113 cancel_skill_rate">
                      <div className="text-block-81 add_skill_text cancel">
                        Cancel
                      </div>
                    </div>
                    <div className="div-block-113 confirm_skill_rate">
                      <div className="text-block-81 add_skill_text">
                        Confirm
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </span>
    );
  }
}

export default StartView;

/* eslint-enable */
